import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import Root from './components/Root.jsx'


ReactDOM.render(
    <Root/>,
    document.getElementById('react-view')
);



// WEBPACK FOOTER //
// ./app/entry/app.js